import styled from "@emotion/styled";

export const FormControl = styled.div`
  width: 100%;
`;
export const FormLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  color: #253858;
  line-height: normal;
  margin-bottom: 8px;
`;
export const FormHelperText = styled.p`
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.217px;
  white-space: nowrap;
  color: #000000;
`;

export const MultipleText = styled.p`
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 1;
`;
